import { fetchWithAuth } from '../auth/fetchWithAuth';
import { notifyError, notifySuccess } from '../components/Toast';

const API_REPORTES_URL = `${process.env.REACT_APP_API_BASE_URL}reportes`;

export const loadMatrix = (idPei, user)  => {
  return async (dispatch) => {
    dispatch({ type: 'LOAD_MATRICES_REQUEST' });
    try {
      const params = new URLSearchParams();
      if (idPei) params.append('pei', idPei);

      const qs = params.toString();
      const response = await fetchWithAuth(`${API_REPORTES_URL}/matrices${qs ? `?${qs}` : ''}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      },dispatch);

      if (response.ok) {
        const data = await response.json();
        dispatch({ type: 'LOAD_MATRICES_SUCCESS', payload: data });
      } else {
        const errorData =  response.text();
        dispatch({ type: 'LOAD_MATRICES_FAIL', payload: errorData });
      }
        
    } catch (error) {
      dispatch({ type: 'LOAD_MATRICES_FAIL', payload: error.message });
    }
  }
};

export const loadMatrixFull = (matrixId, user)  => {
  return async (dispatch) => {
    dispatch({ type: 'LOAD_MATRICES_REQUEST' });
    try {
      const response = await fetchWithAuth(`${API_REPORTES_URL}/matrices`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      },dispatch);

      if (response.ok) {
        const data = await response.json();
        dispatch({ type: 'LOAD_MATRICES_SUCCESS', payload: data });
      } else {
        const errorData =  response.text();
        dispatch({ type: 'LOAD_MATRICES_FAIL', payload: errorData });
      }
        
    } catch (error) {
      dispatch({ type: 'LOAD_MATRICES_FAIL', payload: error.message });
    }
  }
};

export const saveMatrix = (idPei, matrix, user) => {
  return async (dispatch) => {
    dispatch({ type: 'SAVE_MATRIX_REQUEST' });
    try {

      const resp = await fetchWithAuth(`${API_REPORTES_URL}/planes-estrategicos/${idPei}/matrices`,{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token,
        },
        body: JSON.stringify(matrix),
      },dispatch );

      if (resp === null) return;

      if (!resp.ok) {
        const msg = await resp.text();
        dispatch({ type: 'SAVE_MATRIX_FAIL', payload: msg });
        notifyError(msg || 'Ocurrio un error al guardar la matriz');
        return false;
      }

      dispatch({ type: 'SAVE_MATRIX_SUCCESS' });
      dispatch(loadMatrix(idPei,user));
      notifySuccess('Matriz guardada correctamente');
      return true;

    } catch (err) {
      dispatch({ type: 'SAVE_MATRIX_FAIL', payload: err.message });
      notifyError('Error de conexión');
      return null;
    }
  };
};

export const deleteMatrix = (matrixId, user) => {
  return async (dispatch) => {
    dispatch({ type: 'DELETE_MATRIX_REQUEST', payload: matrixId });
    try {

      const response = await fetchWithAuth(`${API_REPORTES_URL}/matrices/${matrixId}`,{
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token,
        }
      },dispatch );

      if (response.ok) {
        dispatch({ type: 'DELETE_MATRIX_SUCCESS', payload: matrixId });
        notifySuccess('Matriz eliminada correctamente');
        return true;
      } else {
        const msg = await response.text();
        dispatch({ type: 'DELETE_MATRIX_FAIL', payload: msg });
        notifyError(msg || 'Ocurrio un error al eliminar la matriz');
        return false;
      }
    } catch (err) {
      dispatch({ type: 'SAVE_MATRIX_FAIL', payload: err.message });
      notifyError('Error de conexión');
      return null;
    }
  };
};

export const loadThemes = (user) => {
  return async (dispatch) => {
    dispatch({ type: 'LOAD_THEMES_REQUEST' });

    try {
      const response = await fetchWithAuth(`${API_REPORTES_URL}/matrices/tematicas`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token,
        },
      },dispatch);

      if (response.ok) {
        const data = await response.json();
        dispatch({ type: 'LOAD_THEMES_SUCCESS', payload: data });
        return true;
      } else {
        const raw = await response.text();
        dispatch({ type: 'LOAD_THEMES_FAIL', payload: raw });
        return false;
      }
    } catch (error) {
      dispatch({ type: 'LOAD_THEMES_FAIL', payload: error.message });
      return null;
    }
  };
};

export const loadCategories = (user) => {
  return async (dispatch) => {
    dispatch({ type: 'LOAD_CATEGORIES_REQUEST' });

    try {
      const response = await fetchWithAuth(`${API_REPORTES_URL}/matrices/categorias`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token,
        },
      },dispatch);

      if (response.ok) {
        const data = await response.json();
        dispatch({ type: 'LOAD_CATEGORIES_SUCCESS', payload: data });
        return true;
      } else {
        const raw = await response.text();
        dispatch({ type: 'LOAD_CATEGORIES_FAIL', payload: raw });
        return false;
      }
    } catch (error) {
      dispatch({ type: 'LOAD_CATEGORIES_FAIL', payload: error.message });
      return null;
    }
  };
};
